import { FC } from 'react';

const IconAddToCart: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5256_8566)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C6.89543 2 6 2.89543 6 4H10C10 2.89543 9.10457 2 8 2ZM8 0C5.79086 0 4 1.79086 4 4H0L1.5822 13.4932C1.82329 14.9398 3.07486 16 4.54138 16H8V14H4.54138C4.05254 14 3.63535 13.6466 3.55499 13.1644L2.36092 6H13.6391L13.4724 7L13.3057 8H15.3333L15.5 7L16 4H12C12 1.79086 10.2091 0 8 0ZM13.5 9V11.5H16V13.5H13.5V16H11.5V13.5H9V11.5H11.5V9H13.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5256_8566">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { IconAddToCart };
